<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" v-on="on">
                        <v-icon dark left>add</v-icon>
                        {{$t('lang.common.add')}}
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{$t( formTitle) }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>


                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.applicant')"
                                                  :data-vv-as="$t('lang.files.applicant')"
                                                  v-model="editedItem.applicant"
                                                  name="applicant"
                                                  :error-messages="errors.first('applicant')"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.applicantAddress')"
                                                  :data-vv-as="$t('lang.files.applicantAddress')"
                                                  v-model="editedItem.applicantAddress"
                                                  name="applicantAddress"
                                                  :error-messages="errors.first('applicantAddress')"></v-text-field>

                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--                        <v-btn color="primary" flat @click="save">-->
                        <v-btn color="primary" @click="save">
                            <v-icon dark left>save</v-icon>
                            {{$t('lang.common.save')}}
                        </v-btn>

                        <v-btn color="error" @click="close">
                            <v-icon dark left>cancel</v-icon>
                            {{$t('lang.common.cancel')}}
                        </v-btn>
<!--                        <v-btn color="error" flat @click="close">Cancel</v-btn>-->

                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1 gru-table fixed-header"
        >
            <template slot="headers">
                <tr>
                    <th v-for="header in headers" :width="header.width"
                    >
                        {{$t(header.text)}}

                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <td >{{ props.item.applicant }}</td>
                <td >{{ props.item.applicantAddress }}</td>
                <td class="justify-center layout px-100">
                    <v-btn depressed outline icon fab dark color="primary" small @click="editItem(props.item)"
                           title="Clear">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn depressed outline icon fab dark color="red" small @click="deleteItem(props.item)" title="Clear">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </template>
            <template v-slot:no-data>
                Không có dữ liệu
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        name: "ApplicantComponent",
        props: {
            defaultData: {
                type: Array,
                default: () => []
            },
            formName: {
                type: String,
                default: 'Application List'
            },
        },
        data: () => ({
            dialog: false,
            headers: [
                {
                    text: 'lang.files.applicant',
                    align: 'center',
                    value: 'applicant',
                    width: "20%"
                },
                {
                    text: 'lang.files.applicantAddress',
                    align: 'center',
                    value: 'applicantAddress',
                    width: "70%",
                    sortable: false
                }

            ],
            items: [],
            addLabel: 'lang.files.add',
            editLabel: 'lang.files.edit',
            editedIndex: -1,
            editedItem: {
                applicant: '',
                applicantAddress: ''
            },
            defaultItem: {
                applicant: '',
                applicantAddress: ''
            }
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.addLabel : this.editLabel
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
            defaultData: function (value) {
                this.items = this.copyValue(value);
            }
        },

        created() {
        },

        methods: {
            copyValue: function (value) {
                let ob = value.slice();
                return ob;
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                const index = this.items.indexOf(item)
                confirm('Bạn có chắc chắn xóa ?') && this.items.splice(index, 1)
                this.$emit("input", this.items);
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$validator.validate().then(
                    valid => {
                        if (!valid) {
                            message.error(this.$t('lang.common.validate_fail'));
                            return;
                        }
                        if (this.editedIndex > -1) {
                            Object.assign(this.items[this.editedIndex], this.editedItem)
                        } else {
                            this.items.push(this.editedItem)
                        }
                        this.close()
                        this.$emit("input", this.items);

                    }
                )

            }
        }
    }
</script>